<template>
  <div class="trend">
      <div class="label_conside">
         <span class="label">电度数</span>
      </div>
      <div class="chart_wrap">
        <div class="chart_inline_wrapper" ref="eledegChart"></div>
      </div>
    </div>
</template>

<script>
//import eledegChart from '@/components/now/trend/EledegChart'
    const echarts = require('echarts');
    var moment = require('moment');
export default {
  props: ['eledegData'],
        mounted(){
            this.getEchart()
        },
        methods: {
            getEchart(){
                var myChart = echarts.init(this.$refs.eledegChart);
                var that = this;
                var yzData = that.eledegData.map(item => {return item.label})
                var xzData = that.eledegData.map(item => {return item.data[0].eledeg})
                var yData = yzData.splice(1,3)
                var xData = xzData.splice(1,3)
               // console.log(xData)
                let option = {
                title: {
                text: '电度图',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                }
            },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
            },
                xAxis: {
                    type: 'value',
            },
                yAxis: {
                    type: 'category',
                data: yData,
            },
                series: [
                {
                type: 'bar',
                itemStyle:{
                    normal:{
                        color:function(params){
                            var colorList = ['#c23531','#2f4554', '#61a0a8'];
                            var index;
                            if (params.dataIndex >= colorList.length) {
                            index = params.dataIndex - colorList.length;
                            return colorList[index];
                        }
                            return colorList[params.dataIndex];
                        }

                    }
                },
                data: xData
                }
    ]
};

                myChart.setOption(option);
                window.addEventListener('resize', () => {
                myChart.resize();
                })
            }
        }
}
</script>
<style lang="scss" scoped>
   .trend{
            width: 98%;
            height: 380px;
            display: flex;
            margin: 30px 1% 0 1%;
            box-shadow: 0 0 5px rgba(0,0,0,0.3);
            border-radius: 8px;
            padding: 10px;
            box-sizing: border-box;
            background: #fff;
        }
            .label_conside{
                width: 5%;
                max-width: 80px;
                float: left;
                text-align: center;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    width: 22px;
                    background: #ffb607;
                    color: white;
                    border-radius: 20px;
                    text-align: center;
                    padding: 20px 0
                }
            }
            .chart_wrap{
                float: left;
                height: 100%;
                flex: 1;
                margin-right: 20px;
            }
            .chart_inline_wrapper {
        height: 97%;

    }

</style>




// WEBPACK FOOTER //
// src/component/base-device-eledeg.vue